import i18n from '@/i18n';
import { CompanyNeedWorkerStatus } from '@/modules/companyNeed/types/worker';

export const BESOIN_WORKER_SAME_STATUS_CODE = 'BESOIN_WORKER_SAME_STATUS';

const STATUS_LABEL_KEYS: Partial<Record<CompanyNeedWorkerStatus, string>> = {
	[CompanyNeedWorkerStatus.INTERVIEW]:
		'modals.companyNeed.moveWorker.interview',
	[CompanyNeedWorkerStatus.COMPANY_PROPOSED]:
		'modals.companyNeed.moveWorker.proposedToCompany',
	[CompanyNeedWorkerStatus.COMPANY_INTERVIEW]:
		'modals.companyNeed.moveWorker.companyInterview',
	[CompanyNeedWorkerStatus.MISSION_PROPOSED]:
		'modals.companyNeed.moveWorker.missionProposed',
};

interface ApiErrorResponse {
	code?: string;
	details?: {
		status?: string;
	};
}

const getApiErrorData = (error: unknown): ApiErrorResponse | undefined =>
	(error as { response?: { data?: ApiErrorResponse } })?.response?.data;

export const isBesoinWorkerSameStatusError = (error: unknown): boolean =>
	getApiErrorData(error)?.code === BESOIN_WORKER_SAME_STATUS_CODE;

const resolveStatusLabel = (status?: string): string => {
	const labelKey = status
		? STATUS_LABEL_KEYS[status as CompanyNeedWorkerStatus]
		: undefined;
	if (!labelKey) {
		return i18n.global.t(
			'modals.companyNeed.moveWorker.alreadyInStatus.unknownStatus'
		);
	}
	return i18n.global.t(labelKey);
};

export const getBesoinWorkerSameStatusErrorMessage = (
	error: unknown,
	count = 1
): string => {
	const status = getApiErrorData(error)?.details?.status;
	const statusLabel = resolveStatusLabel(status);

	return i18n.global.t(
		'modals.companyNeed.moveWorker.alreadyInStatus.message',
		{ status: statusLabel },
		count
	);
};
